import type { AutoSuggestedWork, Opportunity, UserAccount, UserProfile } from "@/api/queries";

import type { OpportunitiesApplyFormData } from "./opportunitiesApplySchema";

export type OpportunityApiPayload = {
  type: "opportunity";
  songs: string;
  content: string;
  opportunity: string;
  username: string;
  email: string;
  artist: string;
};

export function buildOpportunityPayload(
  data: OpportunitiesApplyFormData,
  cachedSongs: AutoSuggestedWork[],
  oppsData: Opportunity[],
  myAccount: UserAccount | undefined,
  userInfo: UserProfile | undefined,
): OpportunityApiPayload {
  const selectedSongs = data.songList.map((song) => {
    const cached = cachedSongs.find(c => c.workcode === song.workcode);
    const trimmedTitle = song.title.trim();
    return {
      workcode: song.workcode,
      title: trimmedTitle.length > 0 ? trimmedTitle : (cached?.title ?? ""),
    };
  });

  const opportunity = oppsData.find(o => o._id === data.opp)?.name ?? "";

  return {
    type: "opportunity",
    songs: JSON.stringify(selectedSongs),
    content: data.content ?? "",
    opportunity,
    username: userInfo?.username != null ? String(userInfo.username) : "",
    email: userInfo?.email ?? "",
    artist: myAccount?.accountname ?? "",
  };
}
